import React from "react";
import { Clock3, Paperclip, RotateCcw, Stamp } from "lucide-react";
import { formatTimestamp } from "./documentUtils";

// Wave 3 — resubmitted (corrected) versions list. View/sign stay authorized:
// both callbacks route to the parent's authenticated handlers.
const ResubmissionList = ({ revisions, isArchived = false, onView, onSign }) => {
  if (!Array.isArray(revisions) || revisions.length === 0) return null;

  return (
    <div className="file-card__revisions">
      <h4>
        <RotateCcw size={17} aria-hidden="true" /> Resubmitted Versions:
      </h4>
      <ul style={{ paddingLeft: 16 }}>
        {[...revisions]
          .sort((a, b) => Number(a.version) - Number(b.version))
          .map((resub, idx) => (
            <li key={String(resub.fileId || idx)} style={{ marginBottom: 8 }}>
              <span>
                <strong>Version {resub.version || idx + 1}:</strong>{" "}
                {resub.originalName || `Corrected document ${idx + 1}`}
              </span>
              {!isArchived && (
                <>
                  <button
                    type="button"
                    onClick={() => onView(resub)}
                    style={{
                      marginLeft: 10,
                      padding: "4px 8px",
                      fontSize: 12,
                      backgroundColor: "var(--wv-success)",
                      color: "#fff",
                      border: "none",
                      borderRadius: 4,
                      cursor: "pointer",
                    }}
                  >
                    View Corrected Version
                  </button>
                  {(String(resub.fileType || "").includes("pdf") ||
                    /\.(pdf|jpe?g|png)$/i.test(resub.originalName || "")) && (
                      <button
                        onClick={() => onSign(resub)}
                        className="file-card__btn file-card__btn-view"
                        style={{ marginLeft: 8, padding: "4px 8px", fontSize: 12 }}
                      >
                        <Stamp size={14} aria-hidden="true" />
                        Stamp / Sign Corrected Version
                      </button>
                    )}
                </>
              )}
              {resub.submittedAt && (
                <p style={{ margin: 0, fontSize: 12, color: "#6c757d" }}>
                  <Clock3 size={13} aria-hidden="true" /> {formatTimestamp(resub.submittedAt)}
                  {resub.submittedByRole ? ` · ${resub.submittedByRole}` : ""}
                </p>
              )}
              {resub.comment && (
                <p style={{ margin: "2px 0 0", fontSize: 12 }}>{resub.comment}</p>
              )}
            </li>
          ))}
      </ul>
    </div>
  );
};

export const AttachmentList = ({ attachments, isArchived = false, onView }) => {
  if (!Array.isArray(attachments) || attachments.length === 0) return null;

  return (
    <div style={{ marginTop: 15 }}>
      <h4>
        <Paperclip size={17} aria-hidden="true" /> Attached Files:
      </h4>
      <ul style={{ paddingLeft: 16 }}>
        {attachments.map((att, idx) => (
          <li key={String(att.id || idx)} style={{ marginBottom: 8 }}>
            <span>{att.fileName || `Attachment ${idx + 1}`}</span>
            {!isArchived && (
              <button
                type="button"
                onClick={() => onView(att)}
                style={{
                  marginLeft: 10,
                  padding: "4px 8px",
                  fontSize: 12,
                  backgroundColor: "var(--wv-info)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
              >
                View Attachment
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ResubmissionList;
